import * as Yup from "yup";
import { GeneralFieldController } from "./general-field-controller";
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";

export class ClinicalTrialFieldController extends GeneralFieldController {
	override createValidationRule(_initialData: unknown, translation: (key: string) => string): Yup.AnySchema {
		return super.createFieldValidationRuleByDataType(translation);
	}

	override mapInitialValue(value: unknown): unknown {
		return (
			value ||
			this.parent.context.startingPoint?.data[AttributeIdentifiers.ClinicalTrial as any] ||
			""
		);
	}
}
